const colors = {
	standard_dark_blue: '#3D405A',
	standard_med_blue: '#525ca5',
	light_gray: '#DCE0F2',
};

export default colors;